import classNames from 'classnames';

import Card from '../Card';

import styles from './_index.module.scss';

export interface ActionCardProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'title'
> {
  description?: React.ReactNode;
  icon: React.ReactNode;
  isSelected?: boolean;
  title: React.ReactNode;
}

const ActionCard = ({
  className,
  description = null,
  icon,
  isSelected = false,
  title,
  type = 'button',
  ...props
}: ActionCardProps) => {
  return (
    <Card
      {...props}
      aria-pressed={isSelected}
      as="button"
      className={classNames(
        styles['action-card'],
        {
          [styles['is-selected']]: isSelected,
        },
        className
      )}
      type={type}
    >
      <span className={styles['action-card-icon']}>{icon}</span>
      <span className={styles['action-card-content']}>
        <span className={styles['action-card-title']}>{title}</span>
        {description && <span className={styles['action-card-description']}>{description}</span>}
      </span>
    </Card>
  );
};

export default ActionCard;
